import { useCustomAddressStore } from '@libs/common-next';

import { isDeliveryMethodAvailable, useProduct } from '@/entities/product';
import { usePurchaseFormWatch } from '@/entities/purchase-form';

export const useSddTailoredData = () => {
    const { product, isLoading, tailored: productTailored, isError } = useProduct();
    const tailored = isError ? undefined : productTailored;
    const sddAddress = useCustomAddressStore(state => state.address);

    const selectedPurchaseOption = usePurchaseFormWatch('purchaseOption');

    const isAvailableForPurchaseOption = isDeliveryMethodAvailable({
        deliveryMethodName: 'SDD',
        deliveryMethodData: product?.deliveryMethods?.SDD,
        purchaseOption: selectedPurchaseOption ?? 'one-time',
    });

    const sddDeliveryMethod = product?.sku ? tailored?.variants?.[product.sku]?.SDD : undefined;
    const availableStock =
        sddDeliveryMethod &&
        'availableStock' in sddDeliveryMethod &&
        typeof sddDeliveryMethod.availableStock === 'number'
            ? sddDeliveryMethod.availableStock
            : 0;

    return {
        product,
        isError,
        isLoading,
        data: tailored,
        availableStock,
        isAvailableForPurchaseOption,
        streetAddress: sddAddress?.streetLine1,
        isDoorDashAvailable: sddDeliveryMethod?.doorDashValidationSuccess ?? false,
    };
};
